import React from 'react';
import { event } from '@uhg-abyss/web/tools/event';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useModal } from 'src/state/modal';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { styled } from '@uhg-abyss/web/tools/styled';
import { NavDropDownContent } from './NavDropDownContent';
import { useAppNav } from './useAppNav';

const StyledNavMenuPrimitivesItem = styled(NavMenuPrimitives.Item, {
  lineHeight: '20px',
});

const StyledNavMenuPrimitivesList = styled(NavMenuPrimitives.List, {
  gap: '17px',
});

const StyledNavMenuPrimitivesTrigger = styled(NavMenuPrimitives.Trigger, {
  '&.abyss-nav-menu-menu-tigger': {
    padding: '0px 16px 0px 16px',
    position: 'relative',
    zIndex: 1081,
    maxWidth: '1380px',
    justifyContent: 'center',

    '&:focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
});

const StyledNavMenuPrimitivesLink = styled(NavMenuPrimitives.Link, {
  '&.abyss-nav-menu-link': {
    padding: '0px 16px 0px 16px',
    position: 'relative',
    zIndex: 1081,
    maxWidth: '1380px',
    justifyContent: 'center',

    '&:focus': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
});

export const NavMenu = () => {
  const { toggleModal } = useModal.actions();
  const appNavMenuItems = useAppNav();

  const openPermissionsModal = (name) => {
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
  };

  const openNavMenuExitLinkModal = (exitLink, name) => {
    const storageKey = `ExitLink-${exitLink.to}`;
    const allowModalOpen =
      exitLink.modalContent && !storage.local.get(storageKey);
    if (allowModalOpen) {
      toggleModal({
        key: 'NavMenuExitLink',
        isOpen: true,
        toolName: name,
        data: {
          ...exitLink,
          storageKey,
        },
      });
    } else {
      window.open(exitLink.to, '_blank');
    }
  };

  const handleClick = (href, name) => {
    event('NAVIGATION_CLICK', { name });
    window.location.replace(href);
  };

  return (
    <StyledNavMenuPrimitivesList>
      <For each="item" of={appNavMenuItems} index="index">
        <Choose>
          <When condition={item.isBlocked}>
            <StyledNavMenuPrimitivesLink
              data-testid={item.dataTestId}
              onClick={() => openPermissionsModal(item.name)}
            >
              {item.name}
            </StyledNavMenuPrimitivesLink>
          </When>
          <When condition={item.exitLink}>
            <StyledNavMenuPrimitivesLink
              data-testid={item.dataTestId}
              onClick={() => openNavMenuExitLinkModal(item.exitLink, item.name)}
            >
              {item.name}
            </StyledNavMenuPrimitivesLink>
          </When>
          <Otherwise>
            <If condition={item.type === 'link'}>
              <StyledNavMenuPrimitivesLink
                data-testid={item.dataTestId}
                onClick={() => handleClick(item.href, item.name)}
              >
                {item.name}
              </StyledNavMenuPrimitivesLink>
            </If>
            <If condition={item.type === 'dropdown'}>
              <StyledNavMenuPrimitivesItem data-testid={item.dataTestId}>
                <StyledNavMenuPrimitivesTrigger>
                  {item.name}
                </StyledNavMenuPrimitivesTrigger>
                <NavMenuPrimitives.Content>
                  <NavDropDownContent dropdownKey={item.key} />
                </NavMenuPrimitives.Content>
              </StyledNavMenuPrimitivesItem>
            </If>
          </Otherwise>
        </Choose>
      </For>
    </StyledNavMenuPrimitivesList>
  );
};
